import {FC, memo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {api, hasValue, useT} from '@kcast-fe/core';
import {useScreenSize} from '@kcast-fe/ui-kit';

interface IProps {
  isFinal: boolean;
  threadId?: string | null;
  prevThreadId?: string | null;
}

const ThreadInfoFC: FC<IProps> = ({isFinal, threadId, prevThreadId}) => {
  const {data: threads} = api.threads.useThreadsQuery();

  const {isLessThan768} = useScreenSize();
  const {t} = useT();

  if ((isFinal && !hasValue(threadId)) || threadId === prevThreadId) {
    return <></>;
  }

  return (
    <Box position={isLessThan768 ? 'initial' : 'sticky'} bg={'{colors.bgMain}'} zIndex={1} top={0}>
      <Flex
        m={'0 -16px'}
        p={'0 16px'}
        color={'{colors.textLink}'}
        justifyContent={'flex-end'}
        bg={'{colors.bgMain}'}
        lineHeight={'24px'}
        fontSize={'14px'}
        gap={'4px'}
      >
        {hasValue(threadId) ? (
          (threads?.get(threadId) ?? 'Unknown')
        ) : (
          <Box className={'blinking'}>{t('labels.detecting')}</Box>
        )}
      </Flex>
    </Box>
  );
};

export const ThreadInfo = memo(ThreadInfoFC);
